import React from 'react'
import {
    Navbar, NavbarToggler, NavbarBrand, Nav,
    NavItem, NavLink, Collapse, DropdownItem,
    DropdownToggle, UncontrolledDropdown,
    DropdownMenu, NavbarText,
} from 'reactstrap'
import '../css/QuoteViewController.css'
import { PopOverController } from './modal/PopOverController'
import { AlertModalController, AlertModalModel, errorMessage } from './modal/AlertModalController'
import { TextAreaModalController } from './modal/TextAreaModalController'
import Loader from 'react-loader';
import { Account, Roles } from '../model/Account'
import { TextNormalization, normalizeText } from '../model/TextNormalization'

class PopOversViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
            'displayLoader': 0,
            'modal': [],
            'showHamburger': false,
        }
    }


    // MARK: Use Loader

    turnOnLoader(by=1) {
        this.setState(function(state, props) {
            return {
                displayLoader: state.displayLoader + by
            }
        })
    }

    turnOffLoader() {
        this.setState(function(state, props) {
            return {
                displayLoader: state.displayLoader - 1
            }
        })
    }

    // MARK: Private Functions

    focusOnFirstElementInModal(children=null) {
        if (children === null) {
            children = document.getElementsByClassName('outermodal')
        }
        for (let i = 0; i < children.length; i++) {
            if (children[i].classList.contains('form-control')) {
                children[i].focus()
                return true
            }
            if (this.focusOnFirstElementInModal(children[i].children)) {
                return true
            }
        }

        return false
    }

    // MARK: Modal

    currentModal() {
        return this.state.modal[this.state.modal.length - 1]
    }

    showModal(modal) {
        const functions = this.getParamFunctions()
        modal = React.cloneElement(
            modal, {
                ...functions,
                ...this.props,
            },
        )
        const modals = this.state.modal
        modals.push(modal)
        this.setState({
            'modal': modals,
        }, (a, b, c) => {
            this.focusOnFirstElementInModal()
        })
    }

    closeModal(index=null) {
        let modals = this.state.modal
        if (index === null || index === modals.length -1) {
            modals.pop()
        } else {
            const beginging = modals.splice(0, index)
            modals = [...beginging, ...(modals.splice(1))]
        }
        this.setState({
            modal: modals,
        })
    }

    // MARK: Alert Modal

    showError(err) {
        const index = this.state.modal.length

        this.showAlertModal(
            (new AlertModalModel())
                .setTitle('Error')
                .setMessage(errorMessage(err))
                .addCancelButton((e) => {this.closeModal(index)})
        )
    }

    showAlertModal(model) {
        const index = this.state.modal.length
        this.showModal(
            <AlertModalController model={model}
                onClickCancel={(e) => this.closeModal(index)} />
        )
    }

    /**
     * @param {string} title
     * @param {function} onChanged receives the (optionally normalized) text
     * @param {string} value initial text
     * @param {{normalize: string}} options `normalize` is one of
     *     `TextNormalization` and defaults to `None` (typed text is passed
     *     through untouched). Pass `TextNormalization.Whitespace` for
     *     name-ish fields - it is what keeps a stray newline from minting
     *     a second `Nick` in the assign-to lists.
     */
    showTextFieldModal(title, onChanged, value='', options={}) {
        const index = this.state.modal.length
        const normalize = options.normalize || TextNormalization.None
        this.showModal(
            <TextAreaModalController
                 title={title}
                 value={value}
                 onChange={(value) => {
                     this.closeModal(index)
                     onChanged(normalizeText(value, normalize))
                 }} />
        )
    }


    // MARK: Views

    renderBlueCheck(account) {
        if (!account.verified) {
            return <></>
        }

        return <div dir="auto" style={{
            'width': '18px',
            'height': '18px',
            'float': 'right',
            'marginLeft': '8px',
        }}><svg viewBox="0 0 24 24" aria-label="Verified account"><g><path d="M22.5 12.5c0-1.58-.875-2.95-2.148-3.6.154-.435.238-.905.238-1.4 0-2.21-1.71-3.998-3.818-3.998-.47 0-.92.084-1.336.25C14.818 2.415 13.51 1.5 12 1.5s-2.816.917-3.437 2.25c-.415-.165-.866-.25-1.336-.25-2.11 0-3.818 1.79-3.818 4 0 .494.083.964.237 1.4-1.272.65-2.147 2.018-2.147 3.6 0 1.495.782 2.798 1.942 3.486-.02.17-.032.34-.032.514 0 2.21 1.708 4 3.818 4 .47 0 .92-.086 1.335-.25.62 1.334 1.926 2.25 3.437 2.25 1.512 0 2.818-.916 3.437-2.25.415.163.865.248 1.336.248 2.11 0 3.818-1.79 3.818-4 0-.174-.012-.344-.033-.513 1.158-.687 1.943-1.99 1.943-3.484zm-6.616-3.334l-4.334 6.5c-.145.217-.382.334-.625.334-.143 0-.288-.04-.416-.126l-.115-.094-2.415-2.415c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l1.77 1.767 3.825-5.74c.23-.345.696-.436 1.04-.207.346.23.44.696.21 1.04z" style={{
            // 'color': 'rgb(29, 161, 242)',
            'fill': 'currentColor',
        }}></path></g></svg></div>
    }

    renderNavItem(label, link) {
        return <NavItem>
            <NavLink href={link} style={{
                'color': '#f5f5f7',
            }}>{label}</NavLink>
        </NavItem>
    }

    renderNavDropDown(label, items) {
        return <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret style={{
                'color': '#f5f5f7',
            }}> {label}
            </DropdownToggle>
            <DropdownMenu right>
                {items}
            </DropdownMenu>
        </UncontrolledDropdown>
    }

    renderMenuBar() {
        if (this.props.noNav) {
            return <></>
        }

        function renderLightNavLink(label, link) {
            return <DropdownItem
                    onClick={(e) => {
                        window.location.href = link
                    }}>
                <button type="button" tabindex="0"
                    role="menuitem" class="dropdown-item">
                    <a href={link} className="nav-link-light">{label}</a>
                </button>
            </DropdownItem>
        }

        const account = Account.fromCookieAndLocalStorage()

        return <Navbar
            className='navbar'
            dark
            expand="md">
            { true ? <></> :
        <NavbarBrand href="/jobs" style={{
            'color': '#f5f5f7',
        }}>Jobs</NavbarBrand>
            }
        <NavbarToggler onClick={(e) => {
            this.setState({
                'showHamburger': !this.state.showHamburger,
            })
        }} />
        <Collapse isOpen={this.state.showHamburger} navbar>
          <Nav className="mr-auto" navbar>
            {!(account && account.verified) ? <></> :
                this.renderNavItem('Jobs', '/jobs')
            }
            {this.renderNavItem('New Quote', '/quote')}
            {!(account && account.hasRole(Roles.Asante)) ? <></> :
                this.renderNavDropDown(
                    'Reports', <>
                        {renderLightNavLink('Project Manager Schedule', '/projectmanagerschedule')}
                        {renderLightNavLink('Daily Schedule', '/dailyschedule')}
                        {renderLightNavLink('Ready For Production', '/production')}
                        {renderLightNavLink('In Production', '/releasedforproduction')}
                        {renderLightNavLink('Backlog Report', '/backlogreport')}
                        {renderLightNavLink('Backlog Search', '/backlogsearch')}
                        {renderLightNavLink('Customer Report', '/customerreport')}
                        {account && account.hasRole(Roles.Admin) && renderLightNavLink('Capacity', '/capacity')}
                        {renderLightNavLink('Purchase Order', '/purchaseorder')}
                        {renderLightNavLink('Ready To Be Ordered', '/purchaseorderreadytobeorder')}
                        {renderLightNavLink('Ready To Be Delivered', '/purchaseorderreadytobedelivered')}
                        {renderLightNavLink('Delivered', '/purchaseorderdelivered')}
                        {  Roles.SelectQuery
                            ? renderLightNavLink('Custom Query', '/customsql')
                            : <></>
                        }
                    </>
                )
            }
            {!(account && account.hasRole(Roles.Machine)) ? <></> :
                this.renderNavDropDown(
                    'Machine', <>
                        {renderLightNavLink('Machine Dock', '/machine')}
                        {renderLightNavLink('Machine Impefections', '/machineimperfections')}
                        {renderLightNavLink('Plates Viewer', '/machineplates')}
                        {renderLightNavLink('Charts', '/machineimages')}
                        {renderLightNavLink('Environment', '/environment')}
                    </>
                )
            }
            {!(account && account.verified && account.hasRole(Roles.Customer)) ? <></> :
                this.renderNavDropDown(
                    'Billing', <>
                        {renderLightNavLink('Make Payment', '/payment/makepayment')}
                        {renderLightNavLink('Edit Payment', '/payment/edit')}
                        {renderLightNavLink('Account History', '/payment/accounthistory')}
                        {renderLightNavLink('Account Statements', '/payment/openinvoices')}
                        {account.hasRole(Roles.Admin) ? <>
                            {renderLightNavLink('Admin Payment', '/payment/adminpayments')}
                            {renderLightNavLink('Admin Job Payment', '/payment/adminjobpayments')}
                            {renderLightNavLink('Admin Banks', '/payment/adminbanks')}
                            {renderLightNavLink('Admin Open Invoices', '/payment/openinvoices')}
                        </> : <></>}
                    </>
                )
            }
            {!(account && account.verified && !account.hasRole(Roles.Asante)) ? <></> :
                this.renderNavItem('Report', '/customerreport')
            }
            {!(account && account.verified && (account.hasRole(Roles.Admin) ||
                account.hasRole(Roles.AsanteAdmin) ||
                (account.hasRole(Roles.Customer) && !account.hasRole(Roles.Asante)))) ? <></> :
                this.renderNavDropDown(
                    'Admin', <>
                        {account.hasRole(Roles.Admin) || account.hasRole(Roles.AsanteAdmin) ?
                            renderLightNavLink('Accounts', '/admin/accounts') :
                            renderLightNavLink('Verify Employees', '/admin/accounts')}
                        {account.hasRole(Roles.Admin) ? <>
                            {renderLightNavLink('Addons', '/admin/addons')}
                            {renderLightNavLink('Schedule Template', '/admin/scheduletemplate')}
                            {renderLightNavLink('Equipment', '/admin/equip')}
                            {renderLightNavLink('Global Files', '/admin/globalfiles')}
                            {renderLightNavLink('Drawing Attributes', '/admin/drawingattributes')}
                            {renderLightNavLink('Job Cost', '/jobcost')}
                        </> : <></>}
                    </>
                )
            }
            {!account ? <></> :
                this.renderNavDropDown(
                    <>
                        {account.email}
                        {this.renderBlueCheck(account)}
                    </>,
                    <>
                        {renderLightNavLink('Settings', '/account/settings')}
                        {renderLightNavLink('Company Settings', '/customerinformation')}
                        {renderLightNavLink('Logout', '/api/account/logout')}
                    </>
                )
            }
          </Nav>
          <NavbarText>© Asante Sign Group {(new Date()).getFullYear()}</NavbarText>
        </Collapse>
      </Navbar>
    }

    getParamFunctions() {
        const functions = {}
        const names = ['turnOnLoader', 'turnOffLoader', 'showModal', 'closeModal',
            'showError', 'showAlertModal', 'showTextFieldModal']
        for (let i = 0; i < names.length; i++) {
            functions[names[i]] = (...args) => { this[names[i]](...args) }
        }

        return functions
    }

    renderModals() {
        return this.state.modal.map((m, i) => {
            return <PopOverController
                closeModal={() => this.closeModal()}
                child={m}/>
        })
    }

    render() {
        const functions = this.getParamFunctions()

        return (
            <>
            { this.state.displayLoader > 0 ?
                <div style={{
                    'position': 'fixed',
                    'width': '100%',
                    'height': '100%',
                    'z-index': '999',
                }}>
                    <Loader
                        loaded={false} />
                </div>
                : <></>
            }
            {this.renderModals()}
            <div style={{
                'filter': this.state.modal.length > 0 || this.state.displayLoader > 0 ?
                    'blur(2px)' : 'none'
            }}>
                {this.renderMenuBar()}
                {React.cloneElement(this.props.children, {
                    ...functions,
                    ...this.props
                })}
            </div>
            </>
        )
    }
}

export default PopOversViewController

